import clsx from "clsx"

import styles from "./StepStackItemGroup.module.scss"
import { StepStackItemGroupProps } from "./StepStackItemGroup.types"

export default function StepStackItemGroup({ children, className }: StepStackItemGroupProps) {
    return (
        <div className={clsx(styles.base, className)}>
            <div className={styles.content}>{children}</div>
        </div>
    )
}
